module.exports = "<a href=\"{{vm.hyperlink}}\" target=\"_blank\">{{vm.text}}</a>";